import { Radio, Grid } from '@mui/material';
import React from 'react';
import { gridAPI } from 'api/grid';
import { CustomCellProps } from 'components/common/grid/';

export default function RadioSelectCell({ href, checked, reloadGridData, disabled, data, setGridDataChanged }: CustomCellProps) {
    const isChecked = checked === 'Y';

    const onClick = () => {
        if (!href || isChecked) {
            return;
        }
        gridAPI.updateGridOrder(href).then(() => {
            if (reloadGridData) {
                reloadGridData();
            }
            if (setGridDataChanged) {
                setGridDataChanged(true);
            }
        });
    };

    let dataTest = undefined;
    if (data?.id) {
        dataTest = `radio-select-cell-${data.id}`;
    }

    return (
        <Grid container sx={{ height: 1, alignItems: 'center', justifyContent: 'start' }}>
            <Radio data-test={dataTest} checked={isChecked} onClick={onClick} disabled={disabled ?? false} />
        </Grid>
    );
}
